type TSimpleReview = {
  id: number;
  period_start: string;
  period_end: string;
};

enum TReviewSharingStatus {
  private = "private",
  public = "public",
  turnoverHidden = "turnover_hidden",
}

type TReviewCommunicate = {
  id: number;
  sharing_status: TReviewSharingStatus;
  public_review_url?: string;
  pdf_restitution_url?: string;
  certificate_url?: string;
  scopes_ghg_url?: string;
  scopes_beges_url?: string;
  trajectories_url?: string;
  emission_factors_url?: string;
};

type TMedalData = {
  id: number;
  rating: number;
  medal: "diamond" | "gold" | "silver" | "bronze" | null;
  consecutive_awards_count: number;
  season: string;
  season_year: number;
  any_medals: boolean;
};

export type { TMedalData, TReviewCommunicate, TSimpleReview };
export { TReviewSharingStatus };
